import { useState, useEffect } from 'react';
import { getContext } from '@picsart/miniapps-sdk';

const useParams = (): Record<string, string | string[]> => {
  const locationContext = getContext().general.location;
  const [params, setParams] = useState<Record<string, string | string[]>>(locationContext.getState().params);

  useEffect(() => {
    locationContext.subscribe(
      nextValue => {
        const extractedParams = nextValue.params;
        setParams(extractedParams);
      },
      { needPrevious: true },
    );
  }, [locationContext]);

  return params;
};

export default useParams;
